import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
import Input from 'components/shared/FormElements/Input/textarea';
import useFormData from '../../../useFormData';
import Links from '../../../../shared/Link/Link';

const Jobs = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  const { handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  // Check it we are facing an existing user
  const { ExistingUser } = useFormData();

  // Logic used to validate fields
  const fieldValidation = (name) => {
    return register({ required: `${name} is required` });
  };

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      {!ExistingUser && (
        <SectionStepInfo section="Section 2 of 4" description="About your enquiry" />
      )}

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <legend className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">What is your enquiry regarding jobs at the WMCA?</h2>
        </legend>

        <Links
          link="https://www.wmca.org.uk/careers/current-vacancies#!/"
          classes="wmcads-m-b-lg"
          text="See our current job vacancies"
          target="_blank"
        />

        <Input
          className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
          name="JobsEnquiry"
          label="Enquiry"
          fieldValidation={fieldValidation('Allegation details')}
        />
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default Jobs;
